// src/pages/Home.js

import React from 'react';
import HeroSection from '../../components/HeroSection';
import CarShowcase from '../../components/CarShowcase';
import ServicesSection from '../../components/ServicesSection';
import WhyChooseUs from '../../components/WhyChooseUs';
import ReviewSection from '../../components/ReviewSection';

function Home() {
  return (
    <main>
      <HeroSection />
      <WhyChooseUs />
      <CarShowcase />
      <ReviewSection />
      <ServicesSection />
    </main>
  );
}

export default Home;
